module.exports = __webpack_public_path__ + "img/packages/v2.ed15ff.png";